/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { User } from '@administration-client/user-shared';
import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StateResource } from '@common/tech-shared';
import { ButtonWithSpinnerComponent } from '@odc/component';
import { Observable } from 'rxjs';

@Component({
  selector: 'administration-user-form-save-button',
  imports: [AsyncPipe, ButtonWithSpinnerComponent],
  templateUrl: './user-form-save-button.component.html',
})
export class UserFormSaveButtonComponent {
  @Input() submitStateResource$: Observable<StateResource<User>>;
}
